import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { updateActiveBoxLine } from '@app/store/rtk.cart.store';

import { ICartBoxLine } from '@interfaces';
import QuantityInput from '@components/common/helpers/quantity-input';
import { WPImage } from '@v2/utils/image';
import { useActiveBoxIndex, useIsActiveBoxFull, useIsCategoryFull } from '@app/store/cart.selectors';

export default function ProductLine({ line, editable, setAddedCallback }: { line: ICartBoxLine, editable?: Boolean, setAddedCallback: Function }) {
    const dispatch = useDispatch();
    const count = line.count;
    const isBoxMaxed = useIsActiveBoxFull();
    const isCategoryMaxed = useIsCategoryFull(line.product);
    const activeBoxIndex = useActiveBoxIndex();

    const setCount = (count: number) => {
        dispatch(updateActiveBoxLine({ product: line.product, count }));
    }

    useEffect(() => {
        if (editable && activeBoxIndex !== null && count !== null) {
            setCount(count);
        }
    }, []);

    return (
        <tr>
            <td className="image">
                <WPImage src={line.product.featuredImgUrl}
                alt={line.product.featuredImgAlt || line.product.title} />
            </td>
            <td className="title">
                <>
                    <div>{line.product.title}</div>
                    {editable || <div className="amount">x {count}</div>}
                </>
            </td>
            {editable
                ?
                <td className="count">
                    <QuantityInput
                        count={count}
                        setCount={setCount}
                        size={'medium'}
                        title={line.product.title}
                        isOutOfStock={false}
                        isMaxed={isBoxMaxed || isCategoryMaxed}
                        maxedType={(isCategoryMaxed && !isBoxMaxed) ? line.product.category : null}
                        onAddAction={() => setAddedCallback(true)} />
                </td>
                :
                <td className="price">
                    &#36;{line.price.toFixed(2)}
                </td>
            }
        </tr>
    );
}
